import HomePage from "./pages/home";
function App() {
  return (
    <div className="App">
      <HomePage />
    </div>
  );
}

export default App;
